import { gql } from '@/Types/gql';

export const CREATE_ZOOM_TOKEN = gql(`mutation CreateZoomToken($data: CreateZoomToken!) {
  createZoomToken(data: $data) {
    status
    token
  }
}`);

export const CREATE_ASSESSMENT = gql(`mutation CreateAssessment($data: CreateAssessmentInput!) {
    createAssessment(data: $data) {
      _id
      assessment
    }
  }
`);
